const cached_categories = {}

export function findItemInCategory(category, entityUID) {
	if (cached_categories[entityUID]) {
		return cached_categories[entityUID]
	}
	if (category.items) {
		let i = 0
		const len = category.items.length
		while (i < len) {
			if (category.items[i].entityUID === entityUID) {
				cached_categories[entityUID] = category
				return category
			}
			if (category.items[i].items) {
				const subcategory = findFilterParentCategory(category.items[i].items, entityUID)
				if (subcategory) {
					cached_categories[entityUID] = subcategory
					return subcategory
				}
			}
			i += 1
		}
	}
	return null
}

export function findFilterParentCategory(categories, entityUID) {
	if (cached_categories[entityUID]) {
		return cached_categories[entityUID]
	}
	let i = 0, category
	const len = categories.length
	while (i < len) {
		category = findItemInCategory(categories[i], entityUID)
		if (category) {
			break
		}
		i += 1
	}
	if (category) {
		cached_categories[entityUID] = category
	}
	return category
}
